function camelToSnakeCase(camelCase) {
  return camelCase.replace(/[A-Z]/g, (match) => '_' + match.toLowerCase())
}

const prepareApiRequest = ({ apiUrl, apiToken, endpoint }) => {
  return {
    url: `${apiUrl}${endpoint}`,
    headers: {
      'Authorization': `Bearer ${apiToken}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    mode: 'cors'
  }
}

const withResponseHandling = async (res) => {
  let json
  try {
    json = await res.json()
  } catch(e) {
    return Promise.reject(new Error(`Content ist kein JSON: ${e.message}`))
  }

  if (res.ok) {
    return json
  } else {
    throw new Error(`Api Error: ${JSON.stringify(json)}`)
  }
}

const isOrganisationPrioritized = ({ organisation, filterCountryCode, filterContext }) => {
  // TODO filter by start/end date
  const activePriorityPlacements = organisation.priority_placements

  if (activePriorityPlacements.length === 0) {
    return false
  }

  let potentialPlacements = activePriorityPlacements.filter(({ country_code }) => {
    if (filterCountryCode) {
      return country_code === filterCountryCode
    } else {
      // api responds with empty string when no countryCode is explicitly set
      // but `undefined != ""` and also `null != ""`
      return country_code === ""
    }
  })

  if (potentialPlacements.length === 0) {
    return false
  }

  potentialPlacements = potentialPlacements.filter(({ context }) => {
    if (filterContext) {
      return context === filterContext
    } else {
      // api responds with empty string when no context is explicitly set
      // but `undefined != ""` and also `null != ""`
      return context === ""
    }
  })

  return potentialPlacements.length > 0
}

export {
  camelToSnakeCase,
  prepareApiRequest,
  withResponseHandling,
  isOrganisationPrioritized,
}
